<div class="dialog-container">
    @if (data) {
        <div mat-dialog-content>
            <h2>{{data.title}}</h2>
            @for (p of safeParagraphs; track $index) {
                <div class="paragraph" [innerHTML]="p"></div>
            }
        </div>
    }
    <div mat-dialog-actions>
        @for (l of data.links; track l) {
            <button mat-raised-button (click)="closeDialog(l.action)" color="accent" [matTooltip]="l.tooltip">{{l.label}}</button>
        }
    </div>
</div>
